<template>
	<div class="component-content" :class="{ 'container-center': center }">
		<div class="item" :class="{ 'item-center': center }">
			<block-notification
				v-show="showFixed"
				:text="message"
				title="Aguarde"
				:type="classs"
			/>
		</div>
		<corner-notification
			v-show="showCorner"
			:text="message"
			:info="classs"
			:type="classs"
			@close="() => this.showNotification = false"
		/>
	</div>
</template>

<script>

// import getUniqueID from '@/helpers/getUniqueID'

import BlockNotification from '@/components/shared/BlockNotification'
import CornerNotification from '@/components/shared/CornerNotification'

export default {
	name: 'WebsocketTest',
	components: { BlockNotification, CornerNotification },
	data () {
		return {
			showFixed: false,
			showCorner: false,
			center: true,
			message: 'Websocket: Unknow data received Websocket: Unknow data received Websocket: Unknow data received Websocket: Unknow data received ',
			classs: 'info'
		}
	},
	created () {
		this.$options.sockets.onmessage = function (e) {
			if (typeof e.data === 'string') {
				const payload = JSON.parse(e.data)
				this.notification(payload.notification)
			} else {
				throw new Error('Websocket: Unknow data received.')
			}
		}
	},
	methods: {
		notification (notification) {
			this.resetNotifications()

			this.message = notification.msg
			this.type = notification.type
			this.classs = notification.classs

			switch (this.type) {
			case 'fixed':
				this.fixedNotification()
				break
			case 'corner':
				this.cornerNotification()
				break
			default:
				this.cornerNotification()
				break
			}
		},
		fixedNotification () {
			this.showFixed = true
			this.center = true
		},
		cornerNotification () {
			this.showCorner = true
			this.center = false
			setTimeout(() => { this.showCorner = false }, 5000)
		},
		resetNotifications () {
			this.showFixed = false
			this.showCorner = false
			this.center = false
		}
	}
}
</script>

<style lang="scss" scoped>
	.component-content {
		&.container-center {
			position: fixed;
			z-index: 5;
			left: 50%;
			width: max-content;
		}
		.item {
			&.item-center {
				position: relative;
				left: -50%;
			}
		}
	}
</style>
